import { defineMessages } from 'react-intl';

export default defineMessages({
  notesSectionTitle: {
    defaultMessage: 'Notes',
    description: 'Title for the notes section',
    id: '+8MEf1',
  },
  sectionAriaLabel: {
    defaultMessage: 'Notes expander section',
    description: 'Aria label for the expandable notes section',
    id: 'QAla6X',
  },
  returnNoteLabel: {
    defaultMessage: 'Return Note',
    description: 'Label for the return note field',
    id: 'FmOuv9',
  },
});
